import { z } from 'zod';
/** Eod demo-data slice — End-of-Day report sessions (EOD_SESSIONS, script lines 950–967) and the preparation
 *  bypass/override history (EOD_BYPASS_HISTORY, script lines 968–983). Deterministic, seeded, labeled simulated. */
export const EodSessionSchema = z
  .object({
    off: z.number(), // day offset from the present (0 = today); indexes REV_DAYS
    acct: z.string(),
    started: z.boolean(),
    // Nullable since 2026-08-28: a session closed without its rules ever being evaluated — armed and abandoned,
    // or force-closed — has NO adherence figure, and the first real report JOB-EOD froze proved it: the reader's
    // contract refused the writer's truth and the whole screen died on a legitimate state. Null means "not
    // measured", which the screen renders as an em dash rather than as 0% — a trader who followed no rules and a
    // trader whose rules were never checked are different facts.
    rulesFollowed: z.number().nullable(),
    redFlags: z.number(),
    lockouts: z.number(),
    bypassed: z.boolean(),
    bypassedAt: z.string().optional(),
    auto: z.boolean(),
    planned: z.array(z.string()),
    tips: z.array(z.string()),
    summary: z.string(),
  })
  .strict();
export const EodOverrideSchema = z.object({ flags: z.array(z.string()), reason: z.string() }).strict();
export const EodBypassSessionSchema = z
  .object({
    off: z.number(),
    pnl: z.number(),
    trades: z.number(),
    wr: z.number(),
    bypassed: z.boolean(),
    at: z.string().optional(),
    override: EodOverrideSchema.optional(),
  })
  .strict();
export const EodDataSchema = z
  .object({
    eodSessions: z.array(EodSessionSchema),
    eodBypassHistory: z.array(EodBypassSessionSchema),
  })
  .strict();
export type EodData = z.infer<typeof EodDataSchema>;
export type EodSession = z.infer<typeof EodSessionSchema>;
export type EodBypassSession = z.infer<typeof EodBypassSessionSchema>;
export type EodOverride = z.infer<typeof EodOverrideSchema>;
